import script from "./RequestMaterialReturn.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestMaterialReturn.vue?vue&type=script&setup=true&lang=js"

import "./RequestMaterialReturn.vue?vue&type=style&index=0&id=f7e45de4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7e45de4"]])

export default __exports__